document.addEventListener('DOMContentLoaded', function () {
  const ingredientSliders = document.querySelectorAll('.ingredient-swiper');

  ingredientSliders.forEach((slider, index) => {
    const storageKey = `ingredient-slider-${index}`;

    const savedIndex = localStorage.getItem(storageKey);

    const swiper = new Swiper(slider, {
      loop: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
      speed: 700,
      spaceBetween: 20,

      initialSlide: savedIndex ? parseInt(savedIndex) : 0,

      slidesPerView: 1,

      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 50
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 24
        }
      },

      on: {
        slideChange: function () {
          localStorage.setItem(storageKey, this.realIndex);
        }
      }
    });
  });
});